export const SharedImages = {
  loading: require('./loading.svg'),
  buttonLoading: require('./buttonLoading.svg'),
  popUpBackground: require('./popUpBackground.svg'),
  close: require('./close.svg'),
  mail: require('./mail.svg'),
  globe: require('./globe.svg'),
  message: require('./message.svg'),
  delete: require('./delete.svg'),
  cancel: require('./cancel.svg'),
  user: require('./user.svg'),
  defaultCheckBox: require('./defaultCheckbox.svg'),
  check: require('./checkbox.svg'),
  profilePlaceholder: require('./no-photo.svg'),
  nextMonth: require('./nextMonth.svg'),
  prevMonth: require('./prevMonth.svg'),
  rotateClockwise: require('./rotateClockwise.svg'),
  checkMark: require('./check.svg'),
  clear: require('./clear.svg'),
  userAdd: require('./userAdd.svg'),
  bookmark: require('./bookmark.svg'),
  export: require('./externalLink.svg'),
};
